export default "__VITE_ASSET__BHX3bd1F__"